import $ from "jquery";

const Images = {
  ACTIVE_THUMBNAIL_CLASS: "thumbnail-image-list__item--active",
  SEEN_TOOLTIP_STORAGE_KEY: "tds.seenPortfolioThumbnailTooltip",

  /**
   * Swap out the browser image with the one clicked.
   * @param  {object} event
   */
  onThumbnailClick(event) {
    event.preventDefault();
    const $el = $(event.currentTarget);
    this.$thumbs.not($el).removeClass(this.ACTIVE_THUMBNAIL_CLASS);
    $el.addClass(this.ACTIVE_THUMBNAIL_CLASS);
    this.replaceImage($el);
  },

  /**
   * Replace the active image.
   * @param {element} $thumbnail
   */
  replaceImage($thumbnail) {
    const title = $thumbnail.attr("data-title");
    this.$activeImg.prop("src", $thumbnail.find("img").attr("src"));
    this.$activeImg.prop("alt", title);
    this.$activeImageLink.attr("data-title", title);
    this.$activeImageLink.attr("data-index", $thumbnail.attr("data-index"));
    this.$activeImageLink.attr(
      "data-media-url",
      $thumbnail.attr("data-media-url")
    );
  },

  /**
   * Init this module.
   */
  init() {
    this.$activeImageWrapper = $(".thumbnail-target");
    this.$thumbs = $(".thumbnail-image-list__item");
    this.$activeImg = this.$activeImageWrapper.find(".thumbnail-target__img");
    this.$activeImageLink = this.$activeImageWrapper.find(
      ".modal-media-trigger"
    );
    this.$thumbs.on("click", this.onThumbnailClick.bind(this));
  },
};
export default Images;
